import { render, staticRenderFns } from "./ModalSeoSettings.vue?vue&type=template&id=6fab75bb&scoped=true&"
import script from "./ModalSeoSettings.vue?vue&type=script&lang=js&"
export * from "./ModalSeoSettings.vue?vue&type=script&lang=js&"
import style0 from "./ModalSeoSettings.vue?vue&type=style&index=0&id=6fab75bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fab75bb",
  null
  
)

export default component.exports